"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EEValidator = void 0;
const config_1 = require("../../config");
const CountryValidator_class_1 = require("../CountryValidator.class");
const EEPersonalId_class_1 = require("./EEPersonalId.class");
class EEValidator extends CountryValidator_class_1.CountryValidator {
    constructor(channel = config_1.CountryChannel.EE) {
        super(channel);
    }
    isValidPersonalId(value) {
        return new EEPersonalId_class_1.EEPersonalId(value).isValid();
    }
    getGenderByPersonalId(value) {
        return new EEPersonalId_class_1.EEPersonalId(value).getGender();
    }
    isValidPostalCode(value) {
        return String(value).length === EEValidator.POSTAL_CODE_LENGTH &&
            parseInt(value) >= EEValidator.POSTAL_CODE_MIN &&
            parseInt(value) <= EEValidator.POSTAL_CODE_MAX;
    }
    isPaymentDescriptionContainsOnlyValidSymbols(value) {
        return /^[0-9a-zA-ZŠŽÕÄÖÜšžõäöü/\-!?:().,'+ ]*$/.test(value);
    }
}
exports.EEValidator = EEValidator;
EEValidator.POSTAL_CODE_LENGTH = 5;
EEValidator.POSTAL_CODE_MIN = 10000;
EEValidator.POSTAL_CODE_MAX = 99999;
EEValidator.ID_CODE_MASK = '00000000000';
